/**
 * championKitBootSkirmisher — Yasuo / Riven / Irelia dispatchers (SPY-810).
 */
import { registerChampionDispatcher } from './abilityDispatcher.js';
import {
  castYasuoQ, castYasuoW, castYasuoE, castYasuoR
} from '../domain/champions/yasuo.js';
import {
  castRivenQ, castRivenW, castRivenE, castRivenR
} from '../domain/champions/riven.js';
import {
  castIreliaQ, castIreliaW, castIreliaE, castIreliaR
} from '../domain/champions/irelia.js';

export const SPY810_SKIRMISHER_KEYS = ['yasuo', 'riven', 'irelia'];

registerChampionDispatcher('yasuo', {
  Q(player, worldPos, _projectiles, gameTime, entities) {
    const bucket = [];
    if (!castYasuoQ(player, worldPos.x, worldPos.y, bucket, gameTime, entities)) return null;
    return { type: 'yasuo_q', projectiles: bucket, cooldown: 4.0 };
  },
  W(player, worldPos, _projectiles, gameTime) {
    if (!castYasuoW(player, worldPos?.x, worldPos?.y, gameTime)) return null;
    return { type: 'yasuo_w', projectiles: [], cooldown: 30.0 };
  },
  E(player, worldPos, _projectiles, _gameTime, entities) {
    if (!castYasuoE(player, worldPos.x, worldPos.y, entities)) return null;
    return { type: 'yasuo_e', projectiles: [], cooldown: 0.5 };
  },
  R(player, _worldPos, _projectiles, _gameTime, _entities, selectedTarget) {
    if (!selectedTarget) return null;
    if (!castYasuoR(player, selectedTarget)) return null;
    return { type: 'yasuo_r', projectiles: [], cooldown: 70.0 };
  }
});

registerChampionDispatcher('riven', {
  Q(player, _worldPos, _projectiles, _gameTime, entities) {
    if (!castRivenQ(player, entities)) return null;
    return { type: 'riven_q', projectiles: [], cooldown: 13.0 };
  },
  W(player, _worldPos, _projectiles, _gameTime, entities) {
    if (!castRivenW(player, entities)) return null;
    return { type: 'riven_w', projectiles: [], cooldown: 11.0 };
  },
  E(player, worldPos) {
    if (!castRivenE(player, worldPos?.x, worldPos?.y)) return null;
    return { type: 'riven_e', projectiles: [], cooldown: 10.0 };
  },
  R(player, worldPos, _projectiles, _gameTime, entities) {
    if (!castRivenR(player, entities, worldPos?.x, worldPos?.y)) return null;
    return { type: 'riven_r', projectiles: [], cooldown: 120.0 };
  }
});

registerChampionDispatcher('irelia', {
  Q(player, worldPos) {
    if (!castIreliaQ(player, worldPos.x, worldPos.y)) return null;
    return { type: 'irelia_q', projectiles: [], cooldown: 10.0 };
  },
  W(player) {
    if (!castIreliaW(player)) return null;
    return { type: 'irelia_w', projectiles: [], cooldown: 20.0 };
  },
  E(player, worldPos, _projectiles, gameTime, entities) {
    const bucket = [];
    if (!castIreliaE(player, worldPos.x, worldPos.y, bucket, gameTime, entities)) return null;
    return { type: 'irelia_e', projectiles: bucket, cooldown: 16.0 };
  },
  R(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castIreliaR(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'irelia_r', projectiles: bucket, cooldown: 125.0 };
  }
});
